export default "__VITE_ASSET__c3fa8d99__"